var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.652 13.727a2.965 2.965 0 1 0 0-5.93 2.965 2.965 0 0 0 0 5.93Zm.018-1.1a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6ZM18.389 17.535a2.965 2.965 0 1 1-5.931 0 2.965 2.965 0 0 1 5.93 0Zm-2.947 1.864a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.22 13.005 6.352 3.711a2.96 2.96 0 0 1 .643-1.16c-.347-.208-4.347-2.515-6.34-3.669-.107.462-.3.79-.655 1.118ZM12.678 6.155s-.23-.175-.437-.475-.284-.586-.284-.586L5.84 8.762c.298.326.524.718.653 1.152l6.184-3.759Z",
    fill: "#344054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.102 3.692a2.965 2.965 0 1 1-5.93 0 2.965 2.965 0 0 1 5.93 0Zm-2.947 1.864a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z",
    fill: "#344054"
  })));
};
export default SvgShare;